export default __webpack_public_path__ + "static/media/the_globe_preview.png";